module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/widget-duplicados-ok.61294b83.svg";